import {Pipe} from '@angular/core';
import {DateFormatPipe} from 'ngx-moment';
import * as moment from 'moment';

@Pipe({name: 'localTimeFormat'})
// tslint:disable-next-line:use-pipe-transform-interface
export class LocalTimeFormatPipe extends DateFormatPipe {

  public transform(value: Date | moment.Moment | string | number, defaultValue = '', dateFormat = 'LTS'): string {
    if (value == null) {
      return defaultValue;
    }
    let result = super.transform(value, dateFormat);

    if (result.length === 0) {
      result = defaultValue;
    }

    return result;
  }

}
